"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFilterGroup = addFilterGroup;
exports.eachFilterGroup = eachFilterGroup;
exports.mapFilters = mapFilters;
exports.someFilters = someFilters;
/**
 * iterates through each filter, calling the callback to map each one, to construct new filters
 */
function mapFilters(group, callback) {
  const filterGroups = Array.isArray(group.filterGroups) ? group.filterGroups.map(g => mapFilters(g, callback)) : [];
  const filters = 'filters' in group && Array.isArray(group.filters) ? group.filters.map(filter => callback(filter)).filter(f => f != null) : [];
  return Object.assign({}, group, {
    filterGroups,
    filters
  });
}

/**
 * returns true if at least one filter causes the callback to return true
 */
function someFilters(group, callback) {
  let result = false;
  if (group) {
    if (Array.isArray(group.filterGroups)) {
      result = group.filterGroups.filter(g => !g.disabled).some(g => someFilters(g, callback));
    }
    if (!result && 'filters' in group && Array.isArray(group.filters)) {
      result = group.filters.filter(f => !f.disabled).some(f => callback(f));
    }
  }
  return result;
}

/**
 * calls the callback for each filter group in the group
 */
function eachFilterGroup(group, callback) {
  if (group && 'disabled' in group && group.disabled) {
    return;
  }
  if (group && 'filters' in group) {
    callback(group);
  }
  if (group?.filterGroups) {
    group.filterGroups.filter(g => !g.disabled).forEach(g => eachFilterGroup(g, callback));
  }
}
function addFilterGroup(filters, filterGroup, connector = 'All') {
  if (!filters?.filterGroups || filters.filterGroups.length === 0) {
    return {
      connector,
      filterGroups: [filterGroup]
    };
  }
  // add default top level connector if missing
  filters.connector ??= 'All';
  if (filters.connector === connector) {
    return Object.assign({}, filters, {
      filterGroups: filters.filterGroups.concat(filterGroup)
    });
  }
  return {
    connector,
    filterGroups: [{
      filters: [],
      ...filters
    }, filterGroup]
  };
}